// Mock data for The Escape Retreat landing page

export const retreatInfo = {
  name: "The Escape Retreat",
  tagline: "Restore & Renew",
  location: "The Reset Sanctuary, Dominican Republic",
  duration: "4 Nights, 5 Days",
  email: "hello@resetsanctuary.com",
  price: 2997.00,
  currency: "USD"
};

export const upcomingDates = [
  { id: 1, startDate: "March 15, 2025", endDate: "March 19, 2025", spotsLeft: 8 },
  { id: 2, startDate: "April 20, 2025", endDate: "April 24, 2025", spotsLeft: 12 },
  { id: 3, startDate: "May 18, 2025", endDate: "May 22, 2025", spotsLeft: 15 }
];

export const itinerary = [
  {
    day: 0,
    title: "Arrival & Welcome",
    theme: "Arrive • Settle • Connect",
    description: "Travel and arrival at The Reset Sanctuary. Welcome drink reception to begin your journey. Explore the charming village and beautiful surroundings at your own pace. Welcome dinner featuring team-building games and complete program overview.",
    activities: ["Welcome Reception", "Village Exploration", "Team Building Dinner"]
  },
  {
    day: 1,
    title: "Awareness & Gratitude",
    theme: "Awaken • Heal • Create",
    description: "Begin with transformative sunrise meditation with sound bowls (6:00-8:00 AM). Inner Child Healing workshop exploring Maslow's Hierarchy with guided exercises and journaling. Creative expression through music, dance, drawing, or writing. Beach, pool, or jacuzzi relaxation. Sunset dinner on the sand.",
    activities: ["Sunrise Meditation & Sound Bowls", "Inner Child Healing Workshop", "Creative Expression Hour", "Sunset Beach Dinner"]
  },
  {
    day: 2,
    title: "Affirmations",
    theme: "Affirm • Speak • Transform",
    description: "Morning Yoga, Meditation, Sound Bath & Reiki healing session (6:00-8:00 AM). Workshop on Healthy Habits, Routines & Prioritizing Self (9:00 AM-12:00 PM). Cascada waterfall excursion with grounding and eco-grounding exercises in nature. Dinner at local beachfront restaurant.",
    activities: ["Yoga & Reiki Healing", "Healthy Habits Workshop", "Waterfall Excursion", "Beachfront Dinner"]
  },
  {
    day: 3,
    title: "Self-Check-In & Inner Voice",
    theme: "Listen • Honor • Celebrate",
    description: "Closing Workshop on listening to your body, connecting with your inner voice, deepening self-awareness (9:00 AM-12:00 PM). Group outing with lunch and special bonding activity. Closing Ceremony Party and Dinner celebrating your transformation and new connections.",
    activities: ["Inner Voice Workshop", "Group Bonding Outing", "Closing Ceremony Party"]
  },
  {
    day: 4,
    title: "Departure & Mindfulness",
    theme: "Ground • Reflect • Depart Renewed",
    description: "Mindfulness breakfast to ground and reflect. Prepare for departure carrying renewed energy and lasting memories.",
    activities: ["Mindfulness Breakfast", "Reflection Circle", "Departure"]
  }
];

export const benefits = [
  {
    title: "Nervous System Restoration",
    description: "Experience deep stress relief and nervous system reset through meditation, sound healing, and beachfront relaxation. Allow your body to return to a state of calm and balance in our peaceful sanctuary setting.",
    icon: "heart"
  },
  {
    title: "Inner Child Healing",
    description: "Reconnect with your authentic self through guided inner child healing workshops. Release old patterns, embrace self-compassion, and integrate past experiences for lasting emotional freedom and wholeness.",
    icon: "sparkles"
  },
  {
    title: "Empowerment & Connection",
    description: "Discover your power through self-discovery, goal setting, and creative expression. Build healthy habits, unlock joy and playfulness, and forge meaningful bonds with a supportive community of women.",
    icon: "users"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    text: "This retreat changed my life. I finally found the peace and clarity I've been searching for. The combination of healing practices and the supportive sisterhood created a transformative experience I'll carry with me forever.",
    rating: 5
  },
  {
    id: 2,
    name: "Jennifer L.",
    text: "The Reset Sanctuary provided the perfect environment for deep healing. The workshops were profound, and I left with practical tools I use daily. The connections I made with the other women are priceless.",
    rating: 5
  },
  {
    id: 3,
    name: "Maria R.",
    text: "I came feeling burnt out and disconnected. I left feeling renewed, empowered, and deeply connected to myself and others. This retreat is worth every penny. The location, the activities, everything was perfect.",
    rating: 5
  }
];

export const activities = [
  "Meditation & Sound Healing",
  "Yoga & Movement Classes",
  "Reiki Energy Healing",
  "Inner Child Healing Workshops",
  "Grounding Exercises in Nature",
  "Creative Expression & Playtime",
  "Goal Setting & Life Visioning",
  "Waterfall Excursions",
  "Beach, Pool & Jacuzzi Relaxation",
  "Sunset Dinners on the Beach",
  "Team Building & Community Connection",
  "Mindfulness & Self-Care Practices"
];

export const faqs = [
  {
    question: "What's included in the retreat package?",
    answer: "Your retreat package includes 4 nights of luxury accommodation at The Reset Sanctuary, all meals (healthy breakfasts, lunches, and dinners), all workshops and wellness activities, waterfall excursion, welcome reception, closing ceremony, and continuous support from our facilitators."
  },
  {
    question: "What should I bring?",
    answer: "Bring comfortable clothing for yoga and movement, swimwear, sun protection, a journal, any personal medications, and an open heart. We'll provide yoga mats, sound healing equipment, and all materials for workshops."
  },
  {
    question: "Is this retreat suitable for beginners?",
    answer: "Absolutely! Our retreat is designed for women at all levels of wellness experience. Whether you're new to yoga and meditation or have been practicing for years, our facilitators adapt activities to meet you where you are."
  },
  {
    question: "What is the cancellation policy?",
    answer: "We offer a full refund for cancellations made 60+ days before the retreat. Cancellations 30-59 days before receive a 50% refund. Unfortunately, we cannot offer refunds for cancellations within 30 days of the retreat start date."
  },
  {
    question: "Are there dietary accommodations?",
    answer: "Yes! We accommodate vegetarian, vegan, gluten-free, and most dietary restrictions. Simply let us know your needs in the booking form, and our culinary team will ensure you're well taken care of."
  },
  {
    question: "How do I get to the sanctuary?",
    answer: "The Reset Sanctuary is located in the Dominican Republic. We'll provide detailed travel instructions and recommendations upon booking. Airport transfers can be arranged for an additional fee."
  }
];